export const META_TAG_TITLE = '후루츠패밀리 - 빈티지, 세컨핸드 패션 중고거래 앱';


export const FILTER_KEYS = {
  GENDER: "gender",
  SUBCATEGORY_IDS: "subcategoryIds",
  BRANDS: "brands",
  PRICE_MIN: "priceMin",
  PRICE_MAX: "priceMax",
  IS_SELLING: "isSelling",
  CONDITION: "condition",
  SORT: "sort",
};
